import { yup } from '@jbc-year-end-adj/common/yup';
import { HouseHolder } from './query';

const householderNameConditions = {
  is: (householderRelationship: string) => householderRelationship !== '本人',
  then: () =>
    yup
      .string()
      .required()
      .label('世帯主の名前'),
  otherwise: () => yup.string().label('世帯主の名前')
};

export const schema = yup.object({
  householder: yup.object({
    relationship: yup
      .string()
      .required()
      .label('世帯主の続柄'),
    name: yup.string().when('relationship', householderNameConditions)
  })
});

export type Schema = {
  householder?: HouseHolder;
};

export const generateDefaultValues = (householder: HouseHolder | undefined): Schema => {
  return {
    householder: {
      name: householder?.name || '',
      relationship: householder?.relationship || '本人'
    }
  };
};
